import { HomeIcon } from "lucide-react";

// 자주찾는 메뉴 띠의 고정 문구와 기본 목록. 띠는 `Layout` 이 모든 로그인 후 화면
// 위에 그린다(`components/quick-menu`).

/** 자주찾는 메뉴 띠의 제목. 그대로 섹션의 접근성 이름이 된다. */
export const QUICK_MENU_TITLE = "자주찾는 메뉴";

/** 설정 다이얼로그의 제목과 안내. */
export const QUICK_MENU_SETTINGS_TITLE = "자주찾는 메뉴 설정";
export const QUICK_MENU_SETTINGS_HINT =
  "띠에 보일 메뉴를 고르세요. 홈은 항상 맨 앞에 보입니다.";

/**
 * 자주찾는 메뉴의 첫 칸 — 홈 화면(`/home`).
 *
 * 메뉴 정의에서 "홈" 은 `/home-new` 이고 `/home` 은 "기존 대시보드" 라, 정의에서
 * 골라 오지 않고 여기에 따로 둔다. 로그인 후 도착하는 화면이 `/home` 이라 사용자에겐
 * 이쪽이 "홈" 이다.
 */
export const QUICK_MENU_HOME = {
  title: "홈",
  url: "/home",
  icon: HomeIcon,
};

/**
 * 사용자가 아직 고른 적 없을 때 첫 칸 뒤에 보여줄 페이지.
 *
 * 칸의 순서는 이 목록이 아니라 메뉴 정의의 순서를 따른다. 제목·아이콘은 새로 적지 않고
 * `NAV_SECTIONS`(constants/appSidebar.ts)에서 같은 url 의 항목을 가져온다 — 메뉴 이름이
 * 바뀌면 칸도 따라간다. 현재 팀이나 권한으로 메뉴에서 빠진 페이지는 건너뛴다. 사용자가
 * 고른 목록은 `useQuickMenuStore` 에 저장되고, 있으면 이 목록 대신 쓴다.
 */
export const QUICK_MENU_URLS = [
  "/dashboard",
  "/mind",
  "/public-opinion",
  "/sentiment-analysis",
  "/emotion-preview",
  "/emotion-keywords",
  "/keyword-search",
  "/regional-monitoring",
  "/data-integration-monitoring",
];

/**
 * 메뉴 정의의 제목이 다른 칸과 겹치는 페이지의 칸 이름.
 *
 * `/home-new` 의 메뉴 제목 "홈" 은 첫 칸(`/home`)과 같아서, 고르면 띠에 "홈" 이 둘
 * 생기고 어느 쪽이 어디로 가는지 알 수 없다.
 */
export const QUICK_MENU_LABELS: Record<string, string> = {
  "/home-new": "홈 (신규)",
};
